import React, { FC, useCallback } from 'react';

import { Button } from '@rbilabs/universal-components';

import ActionButton, { ActionButtonVariants } from 'components/action-button';
import Dialog from 'components/dialog';
import { toaster } from 'components/toaster/toaster';
import useUserVerification from 'hooks/use-user-verification';
import { t } from 'state/intl/translations';

interface IUserVerificationModalProps {
  onDismiss: () => void;
  showDialog: boolean;
}

const UserVerificationModal: FC<React.PropsWithChildren<IUserVerificationModalProps>> = ({
  showDialog,
  onDismiss,
}) => {
  const { sendVerificationEmail, loading } = useUserVerification();
  const onVerify = useCallback(
    async (event: any) => {
      event.preventDefault();
      await sendVerificationEmail();
      toaster.positive(t('emailVerificationSent'));
      onDismiss();
    },
    [onDismiss, sendVerificationEmail]
  );
  return (
    <Dialog
      showDialog={showDialog}
      onDismiss={onDismiss}
      modalAppearanceEventMessage="User Verification Modal"
      testID="user-verification-modal"
      heading={t('verifyYourEmail')}
      body={t('verifyYourEmailInstructions')}
      actions={
        <Button.Group>
          <ActionButton
            isLoading={loading}
            fullWidth
            onPress={onVerify}
            testID="user-verification-modal-verify-button"
            mb={2}
          >
            {t('verifyYourEmail')}
          </ActionButton>
          <ActionButton
            disabled={loading}
            variant={ActionButtonVariants.OUTLINE}
            fullWidth
            onPress={onDismiss}
            testID="user-verification-modal-cancel-button"
          >
            {t('cancel')}
          </ActionButton>
        </Button.Group>
      }
    />
  );
};

export default UserVerificationModal;
